import React from 'react';
import {SpinnerBox} from "../spinner/boxes/spinner/spinner.box";
import {CyClass} from "../../../common/cy-classes";
import {SpinnerBrandBox} from "../spinner/boxes/spinner-brand/spinner-brand.box";
import {SpinnerBackgroundBox} from "../spinner/boxes/spinner-background/spinner-background.box";
import {observer} from "mobx-react";

export const DrawerSpinnerComponent: React.FC = observer(() => {
    return (
        <SpinnerBox className={CyClass('cy-spinner')}>
            <SpinnerBrandBox className='cy-spinner-brand'>
                <SpinnerBackgroundBox className='cy-spinner-background'/>
            </SpinnerBrandBox>
        </SpinnerBox>
    );
});